exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1JSFX1_wJSTUebs3RknJLH {\n    margin-top: 32px;\n    margin-bottom: 32px;\n}\n", ""]);

// exports
exports.locals = {
	"root": "_1JSFX1_wJSTUebs3RknJLH"
};